var exports = {
  "Hb": "x127c5a35--6d286e--info_container",
  "DD": "x127c5a35--6d286e--title",
  "ru": "x127c5a35--6d286e--geo_info",
  "rW": "x127c5a35--6d286e--price_info",
  "W1": "x127c5a35--6d286e--title_link",
};

module.exports = exports;
